import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../../Advisor.module.css';
import { CheckSmall } from '../../icons';

const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL;

const Header = () => (
  <header className={styles.hero}>
    <div className={`${styles.container} ${styles.heroGrid}`}>
      <div>
        <div className={`${styles.breadcrumb} ${styles.reveal} ${styles.d1}`}>
          <Link to="/">Fyntiq Business</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <Link to="/#features">Features</Link>
          <span className={styles.breadcrumbSep}>/</span>
          <span className={styles.breadcrumbCur}>Advisors</span>
        </div>
        <h1 className={`${styles.reveal} ${styles.d2}`}>
          Experts in<br /><span className={styles.hl}>your corner.</span>
        </h1>
        <p className={`${styles.heroSub} ${styles.reveal} ${styles.d3}`}>
          Get matched with vetted bookkeepers, accountants, and financial pros who understand small business — and can work right from your Fyntiq records, with your permission.
        </p>
        <div className={`${styles.heroCta} ${styles.reveal} ${styles.d4}`}>
          <Link to={`${dashboardUrl}/signup`} className={styles.btnYellow}>Find an advisor</Link>
          <a href="#how" className={styles.btnOutlineHero}>See how it works</a>
        </div>
        <div className={`${styles.heroNote} ${styles.reveal} ${styles.d5}`}>
          <span><CheckSmall />Vetted professionals</span>
          <span><CheckSmall />On your schedule</span>
        </div>
      </div>

      <div className={`${styles.heroVisual} ${styles.reveal} ${styles.d3}`}>
        <div className={`${styles.floatChip} ${styles.fcCash}`}>
          <div className={`${styles.fcIc} ${styles.fcIcY}`}><CheckSmall /></div>
          <div><div className={styles.fcLab}>Matched</div><div className={styles.fcVal}>In 1 day</div></div>
        </div>
        <div className={`${styles.floatChip} ${styles.fcPayout}`}>
          <div className={`${styles.fcIc} ${styles.fcIcG}`}>
            <svg viewBox="0 0 24 24" width="18" fill="none" stroke="#2EB66E" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </div>
          <div><div className={styles.fcLab}>Verified</div><div className={styles.fcVal}>Pro</div></div>
        </div>

        <div className={styles.payCard}>
          <div className={styles.pcTop}>
            <div className={styles.pcMerchant}>
              <div className={`${styles.pcLogo} ${styles.pcLogoGreen}`}>AR</div>
              <div><div className={styles.pcMname}>A. Rivera, CPA</div><div className={styles.pcMsub}>Bookkeeping &amp; tax</div></div>
            </div>
            <span className={styles.pcPaid}>● Verified</span>
          </div>
          <div className={styles.invRow} style={{ marginTop: 14 }}><span>Specialty</span><span className={styles.mono}>Small business</span></div>
          <div className={styles.invRow}><span>Rating</span><span className={styles.mono}>4.9 ★ (212)</span></div>
          <div className={styles.invRow}><span>Next opening</span><span className={styles.mono}>Thu, 2:00 PM</span></div>
          <button type="button" className={styles.pcPay}>Book a session →</button>
        </div>
      </div>
    </div>
  </header>
);

export default Header;
